(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-hero"]) return;
  try {
    
      var options = {
    accessibility: true,
    prevNextButtons: true,
    pageDots: true,
    setGallerySize: false,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 60,
      y2: 45,
      x3: 15
    }
  };

  var $carousel = $('[data-carousel]').flickity(options);
  var $slideContent = $('.slide-content');
  var flkty = $carousel.data('flickity');
  var selectedSlide = flkty.selectedElement;

  flkty.on('settle', function(index) {
    selectedSlide = flkty.selectedElement;
  });

  flkty.on('change', function(index) {
    $slideContent.eq(index).removeClass('mask');

    setTimeout(function() {
      $slideContent.addClass('mask');
    }, 500);
  });

  flkty.on('dragStart', function(event) {
    var index = 0;
    selectedSlide = flkty.selectedElement;

    if (event.layerX > 0) { // direction right
      index = $(selectedSlide).index() + 1;
    } else { // direction left
      index = $(selectedSlide).index() - 1;
    }

    $slideContent.eq(index).removeClass('mask');
  });

  setTimeout(function() {
    $slideContent.addClass('mask');
  }, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_messages"] && !Shopify.designMode) return;
  try {
    
  var messageWrappers = document.getElementsByClassName('header-message-block');
  if (window.innerWidth > 768 && messageWrappers.length > 1) {
    var idx = 0;
    setInterval(function () {
      if (idx === messageWrappers.length) {
        idx = 0;
      }
      for (var i = 0; i < messageWrappers.length; i++) {
        if (i == idx) {
          messageWrappers[i].style.display = 'block';
        } else {
          messageWrappers[i].style.display = 'none';
        }
      }

      idx++;
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();
})();
